export function presentValue(interest, amount, years) {
  let realInterest = 1.0 + interest;

  while (years >= 1.0) {
    amount *= realInterest; // Apply interest.
    years -= 1;
  }

  realInterest = 1.0 + interest * years;
  amount *= realInterest; // Apply remaining interest.

  return amount;
}

export function applyCola(cola, discount, discountSteps, earn, years) {
  let discountStep = discount / discountSteps; // Divide percentage by amount of steps in year.
  let discountMultiply = 1.0 / (1.0 + discountStep);
  // discountMultiply = 1 - discountStep;
  let colaMultiply = 1.0 + cola;

  let result = 0.0;

  if (years >= 1.0) {
    result += earn; // Start without applying COLA nor PV discount.
    years -= 1;
  }

  while (years >= 1.0) {
    let earnStep = earn / discountSteps; // Divide earning by steps.

    for (let step = 0; step < discountSteps; step++) {
      // print "apply_cola earnStep ", earnStep, "\n"
      result += earnStep;
      // print "apply_cola result ", result, "\n"
      earnStep *= discountMultiply; // Apply PV discount rate.
    }

    earn = earnStep * discountSteps;

    let save = earn;
    earn *= colaMultiply; // Apply cola rate.

    // print "apply_cola earn ", earn, " save ", save, "\n"
    result += (earn - save);
    // print "apply_cola result ", result, "\n"
    years -= 1;
  }

  result += earn * years; // May be less than 1.
  // print "apply_cola result ", result, "\n"

  return result; // (result, earn)
}
